import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/theme.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@coinbase+onchainkit@0.38.19_@farcaster+miniapp-sdk@0.1.8_bufferutil@4.0.9_typescript@5_dae2026d641a23b4cebc8b8665eb118c/node_modules/@coinbase/onchainkit/dist/assets/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.6_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.90.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-figtree\",\"display\":\"swap\"}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/query/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/vercel/path0/redux/reduxProvider.tsx");
